import classNames from "classnames";
import React from "react";
import CSSModules from "lib/utils/css-modules";

import styles from "./SubBar.less";

@CSSModules(styles)
export default class SubBar extends React.PureComponent {
  render() {
    const { hasSidebar = false } = this.props;
    return <div styleName={classNames("container", { hasSidebar })}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/SubBar.jsx